<template functional>
  <span :aria-hidden="props.decorative"
        :aria-label="props.title"
        :class="[data.class, data.staticClass]"
        class="material-design-icon"
        role="img"
        v-bind="data.attrs"
        v-on="listeners">
  <svg :fill="props.fillColor"
       class="material-design-icon__svg"
       :width="props.size"
       :height="props.size"
       viewBox="0 0 24 24">

    <use :xlink:href="'#' + props.icon"></use>
  </svg>
</span>

</template>
<script>
export default {
  props:{
    icon: {
      type: String,
      required: true
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }

}
</script>
